import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, TextArea, ToastContext } from '@weezevent/nacre';

import { useTranslation } from 'react-i18next';

export default function DataModal({ show, onClose, subscription }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const formated_data = React.useMemo(() => JSON.stringify(subscription?.data, undefined, 4), [subscription]);

    const onCopy = React.useCallback(() => {
        navigator.clipboard.writeText(formated_data);
        toast.success(t('ticket.webservice.ticket-list.modal.toast-success'));
        onClose();
    }, [formated_data, onClose, toast]);

    return (
        <Modal
            size="large"
            open={show}
            onClose={onClose}
            title={t('ticket.webservice.ticket-list.modal.title')}
            subtitle={t('ticket.webservice.ticket-list.modal.subtitle')}
            submitButton={
                <Button primary onClick={onCopy}>
                    {t('ticket.webservice.ticket-list.modal.copy')}
                </Button>
            }
            cancelButton={<Button onClick={onClose}>{t('ticket.common.cta.cancel')}</Button>}
        >
            <TextArea disabled value={formated_data} />
        </Modal>
    );
}

DataModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    subscription: PropTypes.object
};
